"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoGetDefaultValueSpecified = void 0;
var tslib_1 = require("tslib");
var NoGetDefaultValueSpecified = /** @class */ (function (_super) {
    tslib_1.__extends(NoGetDefaultValueSpecified, _super);
    function NoGetDefaultValueSpecified(key) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "\nYou are calling `getDefaultValue` for styles param, but it wasn't specified.\nPlease check the `" + key + "` style param implementation.\n") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NoGetDefaultValueSpecified;
}(Error));
exports.NoGetDefaultValueSpecified = NoGetDefaultValueSpecified;
//# sourceMappingURL=NoGetDefaultValueSpecified.js.map